import { render } from "./AllCases.vue?vue&type=template&id=de485db0"
import script from "./AllCases.vue?vue&type=script&lang=js"
export * from "./AllCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/AllCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "de485db0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('de485db0', __exports__)) {
    console.log('reload')
    api.reload('de485db0', __exports__)
  }
  
  module.hot.accept("./AllCases.vue?vue&type=template&id=de485db0", () => {
    console.log('re-render')
    api.rerender('de485db0', render)
  })

}


export default __exports__